import React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { Controller } from "react-hook-form";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {Moment} from "moment";

interface IProps {
  name: string
  error?: any
  label?: string
  control: any
  isRequired?: boolean
  disabled?: boolean
  type?: string
  MUIprops?: any

}


const DateField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const { 
    name, 
    label, 
    control, 
    isRequired, 
    disabled, 
    MUIprops,
  } = props;

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        render={
          ({
            field,
            fieldState: { error },
          }) => (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                value={field.value || ''}
                inputFormat="DD-MM-YYYY"
                disabled={disabled}
                {...MUIprops}
                onChange={(newValue: Moment) => {
                  if (newValue) {
                    field.onChange(newValue.format('YYYY-MM-DD'));
                  }
                }}
                renderInput={(params) => <TextField
                  {...params}
                  required={isRequired}
                  label={label}
                  error={!!error}
                  helperText={error ? error.message : null}
                  inputProps={{
                    ...params.inputProps, ...{
                      'data-testid': field.name
                    }
                  }}
                />}
              />
            </LocalizationProvider>
          )}
      />
    </FormControl>
  );
});

DateField.defaultProps = {
  isRequired: false,
  disabled: false,
};

export { DateField };
